export default __webpack_public_path__ + "static/media/resume.f2599626.pdf";